// Mock data — fácil de substituir por Supabase no futuro.
// Cada array representa uma "tabela" futura no banco.

export const appConfig = {
  nomeComercial: "Grupo Esquematiza",
  nomeSistema: "Vigia Comando",
  logoUrl:
    "https://hybchcireheuheytadxk.supabase.co/storage/v1/object/public/logos/Captura_de_tela_2026-05-07_182902-removebg-preview.png",
  condominioPadrao: "Liberty Place",
  administracao: "Robson Freitas",
  contatoAdministracao: "Tel.: 21 3171-1859 / 1984 / 1988",
};

export const condominios = [
  {
    id: "cond-001",
    nome: "Liberty Place",
    administracao: "Robson Freitas",
    contatoAdministracao: "Tel.: 21 3171-1859 / 1984 / 1988",
    empresaResponsavel: "Grupo Esquematiza",
  },
];

export const postos = [
  { id: "p-01", nome: "Portaria Principal", condominioId: "cond-001" },
  { id: "p-02", nome: "Portaria de Serviço", condominioId: "cond-001" },
  { id: "p-03", nome: "Garagem", condominioId: "cond-001" },
  { id: "p-04", nome: "Área Comum", condominioId: "cond-001" },
];

export const pontosDeRonda = [
  { id: "3f7a1b2c-4d5e-6f78-9a0b-1c2d3e4f5a6b", nome: "Coluna (descida da rampa)", ordem: 1 },
  { id: "7c8d9e0f-1a2b-3c4d-5e6f-7a8b9c0d1e2f", nome: "Fundos da garagem (Bloco 2)", ordem: 2 },
  { id: "a2b3c4d5-e6f7-8901-abcd-ef2345678901", nome: "Lava Jato", ordem: 3 },
  { id: "d4e5f6a7-b8c9-0d1e-2f3a-4b5c6d7e8f9a", nome: "Alojamento / Bicicletário", ordem: 4 },
  { id: "b1c2d3e4-f5a6-7b8c-9d0e-1f2a3b4c5d6e", nome: "Casa de Bombas (Casa 05)", ordem: 5 },
  { id: "e9f0a1b2-c3d4-5e6f-7a8b-9c0d1e2f3a4b", nome: "Casa de Água Servida", ordem: 6 },
  { id: "f8a9b0c1-d2e3-4f5a-6b7c-8d9e0f1a2b3c", nome: "Escada Bloco 1 (Subsolo)", ordem: 7 },
  { id: "0c1d2e3f-4a5b-6c7d-8e9f-0a1b2c3d4e5f", nome: "Escada Bloco 2 (Subsolo)", ordem: 8 },
  { id: "2a3b4c5d-6e7f-8a9b-0c1d-2e3f4a5b6c7d", nome: "Carregador Veículo Elétrico", ordem: 9 },
  { id: "5d6e7f8a-9b0c-1d2e-3f4a-5b6c7d8e9f0a", nome: "Fundos estacionamento (quadra de futebol)", ordem: 10 },
  { id: "8f9a0b1c-2d3e-4f5a-6b7c-8d9e0f1a2b3c", nome: "Restaurante", ordem: 11 },
  { id: "1b2c3d4e-5f6a-7b8c-9d0e-1f2a3b4c5d6f", nome: "Subida da rampa (frente)", ordem: 12 },
];

export const usuarios = [
  {
    id: "u-001",
    nome: "IGOR AUGUSTO DOS SANTOS",
    email: "igoraugustoarmanii@gmail.com",
    senha: "1234",
    tipo: "vigilante",
    funcao: "vigia",
    primeiroAcesso: true,
    ativo: true,
    vigilanteId: "v-001",
  },
  {
    id: "u-002",
    nome: "JONATAS SILVA TRINDADE",
    email: "jonatasgael123@gmail.com",
    senha: "1234",
    tipo: "vigilante",
    funcao: "vigia",
    primeiroAcesso: true,
    ativo: true,
    vigilanteId: "v-002",
  },
  {
    id: "u-003",
    nome: "JORGE PAULO MARTINS",
    email: "martinsjp06@gmail.com",
    senha: "1234",
    tipo: "vigilante",
    funcao: "vigia",
    primeiroAcesso: true,
    ativo: true,
    vigilanteId: "v-003",
  },
  {
    id: "u-004",
    nome: "MATHEUS DE AMORIM MORAES",
    email: "mtmoraes02@gmail.com",
    senha: "1234",
    tipo: "vigilante",
    funcao: "vigia",
    primeiroAcesso: true,
    ativo: true,
    vigilanteId: "v-004",
  },
  {
    id: "u-005",
    nome: "RODRIGO BEJA DE MELLO",
    email: "rodrigobeja@yahoo.com",
    senha: "1234",
    tipo: "vigilante",
    funcao: "vigia",
    primeiroAcesso: true,
    ativo: true,
    vigilanteId: "v-005",
  },
  {
    id: "u-006",
    nome: "MARCELO FIALHO RESSE",
    email: "marceloresse631@gmail.com",
    senha: "1234",
    tipo: "vigilante",
    funcao: "vigia",
    primeiroAcesso: true,
    ativo: true,
    vigilanteId: "v-006",
  },
  {
    id: "u-007",
    nome: "JOSE CARLOS DOS SANTOS SILVA",
    email: "josesolangejulya9@gmail.com",
    senha: "1234",
    tipo: "vigilante",
    funcao: "vigilante",
    primeiroAcesso: true,
    ativo: true,
    vigilanteId: "v-007",
  },
  {
    id: "u-008",
    nome: "CARLOS CESAR DO PRADO E SILVA",
    email: "carllos.cesarprado@gmail.com",
    senha: "1234",
    tipo: "vigilante",
    funcao: "vigilante",
    primeiroAcesso: true,
    ativo: true,
    vigilanteId: "v-008",
  },
  {
    id: "u-009",
    nome: "Luis (Síndico)",
    email: "luis@libertyplace.com.br",
    senha: "1234",
    tipo: "liberty",
    perfil: "sindico",
    primeiroAcesso: true,
    ativo: true,
    vigilanteId: null,
  },
  {
    id: "u-010",
    nome: "Robson Freitas",
    email: "robson@libertyplace.com.br",
    senha: "1234",
    tipo: "liberty",
    perfil: "sindico",
    primeiroAcesso: true,
    ativo: true,
    vigilanteId: null,
  },
  {
    id: "u-011",
    nome: "Galdino",
    email: "galdino@grupoesquematiza.com.br",
    senha: "1234",
    tipo: "esquematiza",
    primeiroAcesso: true,
    ativo: true,
    vigilanteId: null,
  },
  {
    id: "u-012",
    nome: "Rafael Carvalho",
    email: "rafael@grupoesquematiza.com.br",
    senha: "1234",
    tipo: "esquematiza",
    primeiroAcesso: true,
    ativo: true,
    vigilanteId: null,
  },
  {
    id: "u-014",
    nome: "Douglas Braido",
    email: "douglas@grupoesquematiza.com.br",
    senha: "1234",
    tipo: "esquematiza",
    primeiroAcesso: true,
    ativo: true,
    vigilanteId: null,
  },
  {
    id: "u-013",
    nome: "Rafael Carvalho (Dev)",
    email: "rafael.dev@grupoesquematiza.com.br",
    senha: "1234",
    tipo: "esquematiza",
    funcao: "vigilante",
    primeiroAcesso: false,
    ativo: true,
    vigilanteId: "v-009",
  },
  {
    id: "u-015",
    nome: "Galdino (Supervisor)",
    email: "galdino.vig@grupoesquematiza.com.br",
    senha: "1234",
    tipo: "esquematiza",
    funcao: "vigilante",
    primeiroAcesso: false,
    ativo: true,
    vigilanteId: "v-010",
  },
  {
    id: "u-016",
    nome: "Douglas (Gerente)",
    email: "douglas.vig@grupoesquematiza.com.br",
    senha: "1234",
    tipo: "esquematiza",
    funcao: "vigilante",
    primeiroAcesso: false,
    ativo: true,
    vigilanteId: "v-011",
  },
];

export const vigilantes = [
  {
    id: "v-001",
    nome: "IGOR AUGUSTO DOS SANTOS",
    email: "igoraugustoarmanii@gmail.com",
    matricula: "VG-1001",
    condominioId: "cond-001",
    postoId: "p-01",
    emServico: false,
    inicioPlantao: null,
    turno_inicio: "07:00",
    turno_fim: "19:00",
  },
  {
    id: "v-002",
    nome: "JONATAS SILVA TRINDADE",
    email: "jonatasgael123@gmail.com",
    matricula: "VG-1002",
    nr_matricula: "95",
    condominioId: "cond-001",
    postoId: "p-02",
    emServico: false,
    inicioPlantao: null,
    turno_inicio: "19:00",
    turno_fim: "07:00",
  },
  {
    id: "v-003",
    nome: "JORGE PAULO MARTINS",
    email: "martinsjp06@gmail.com",
    matricula: "VG-1003",
    condominioId: "cond-001",
    postoId: "p-03",
    emServico: false,
    inicioPlantao: null,
    turno_inicio: "07:00",
    turno_fim: "19:00",
  },
  {
    id: "v-004",
    nome: "MATHEUS DE AMORIM MORAES",
    email: "mtmoraes02@gmail.com",
    matricula: "VG-1004",
    condominioId: "cond-001",
    postoId: "p-04",
    emServico: false,
    inicioPlantao: null,
    turno_inicio: "07:00",
    turno_fim: "19:00",
  },
  {
    id: "v-005",
    nome: "RODRIGO BEJA DE MELLO",
    email: "rodrigobeja@yahoo.com",
    matricula: "VG-1005",
    condominioId: "cond-001",
    postoId: "p-01",
    emServico: false,
    inicioPlantao: null,
    turno_inicio: "19:00",
    turno_fim: "07:00",
  },
  {
    id: "v-006",
    nome: "MARCELO FIALHO RESSE",
    email: "marceloresse631@gmail.com",
    matricula: "VG-1006",
    condominioId: "cond-001",
    postoId: "p-02",
    emServico: false,
    inicioPlantao: null,
    turno_inicio: "07:00",
    turno_fim: "19:00",
  },
  {
    id: "v-007",
    nome: "JOSE CARLOS DOS SANTOS SILVA",
    email: "josesolangejulya9@gmail.com",
    matricula: "VG-1007",
    nr_matricula: "183",
    condominioId: "cond-001",
    postoId: "p-03",
    emServico: false,
    inicioPlantao: null,
    turno_inicio: "19:00",
    turno_fim: "07:00",
  },
  {
    id: "v-008",
    nome: "CARLOS CESAR DO PRADO E SILVA",
    email: "carllos.cesarprado@gmail.com",
    matricula: "VG-1008",
    condominioId: "cond-001",
    postoId: "p-04",
    emServico: false,
    inicioPlantao: null,
    turno_inicio: "19:00",
    turno_fim: "07:00",
  },
  {
    id: "v-009",
    nome: "Rafael Carvalho (Dev)",
    email: "rafael.dev@grupoesquematiza.com.br",
    matricula: "VG-DEV",
    condominioId: "cond-001",
    postoId: "p-01",
    emServico: false,
    inicioPlantao: null,
    turno_inicio: null,
    turno_fim: null,
  },
  {
    id: "v-010",
    nome: "Galdino (Sup)",
    email: "galdino.vig@grupoesquematiza.com.br",
    matricula: "VG-SUP",
    condominioId: "cond-001",
    postoId: "p-01",
    emServico: false,
    inicioPlantao: null,
    turno_inicio: null,
    turno_fim: null,
  },
  {
    id: "v-011",
    nome: "Douglas (Ger)",
    email: "douglas.vig@grupoesquematiza.com.br",
    matricula: "VG-GER",
    condominioId: "cond-001",
    postoId: "p-01",
    emServico: false,
    inicioPlantao: null,
    turno_inicio: null,
    turno_fim: null,
  },
];

export const rondas = [];

export const categoriasOcorrencia = [
  "Intrusão",
  "Manutenção",
  "Suspeita",
  "Veículo irregular",
  "Barulho",
  "Morador/Visitante",
  "Portaria",
  "Outros",
];

export const ocorrencias = [];

export const emergencias = [];

export const passagensTurno = [];

export const checklistPosto = [
  { id: "ck-1", item: "Verificar portões e cancelas", obrigatorio: true },
  { id: "ck-2", item: "Conferir rádio comunicador", obrigatorio: true },
  { id: "ck-3", item: "Verificar lanterna e baterias", obrigatorio: true },
  { id: "ck-4", item: "Conferir livro de ocorrências físico", obrigatorio: false },
  { id: "ck-5", item: "Testar câmeras da portaria", obrigatorio: true },
  { id: "ck-6", item: "Verificar interfone", obrigatorio: false },
  { id: "ck-7", item: "Receber chaves de plantão", obrigatorio: true },
  { id: "ck-8", item: "Conferir crachá e uniforme", obrigatorio: true },
  { id: "ck-9", item: "Verificar pendências da passagem de turno", obrigatorio: true },
];

export const registrosSistema = [
  {
    id: "log-001",
    usuarioId: "u-001",
    usuarioNome: "IGOR AUGUSTO DOS SANTOS",
    tipoUsuario: "vigilante",
    acao: "login",
    modulo: "Acesso",
    descricao: "Usuário acessou o sistema.",
    detalhes: "Login realizado no app do vigilante.",
    criadoEm: "2026-05-10T07:02:00",
  },
  {
    id: "log-002",
    usuarioId: "u-001",
    usuarioNome: "IGOR AUGUSTO DOS SANTOS",
    tipoUsuario: "vigilante",
    acao: "ronda_concluida",
    modulo: "Rondas",
    descricao: "Ronda concluída.",
    detalhes: "Ronda realizada na Portaria Principal.",
    criadoEm: "2026-05-10T08:34:00",
  },
  {
    id: "log-003",
    usuarioId: "u-002",
    usuarioNome: "JONATAS SILVA TRINDADE",
    tipoUsuario: "vigilante",
    acao: "ocorrencia_criada",
    modulo: "Ocorrências",
    descricao: "Ocorrência registrada.",
    detalhes: "Lâmpada apagada na área de serviço.",
    criadoEm: "2026-05-10T09:12:00",
  },
];

export const modelosRelatorio = [
  {
    id: "rel-001",
    nome: "Relatório geral do plantão",
    tipo: "geral",
    descricao:
      "Resumo completo com rondas, ocorrências, emergências e passagem de turno.",
  },
  {
    id: "rel-002",
    nome: "Relatório de rondas",
    tipo: "rondas",
    descricao: "Lista de rondas realizadas, pontos visitados e horários.",
  },
  {
    id: "rel-003",
    nome: "Relatório de ocorrências",
    tipo: "ocorrencias",
    descricao: "Ocorrências abertas, resolvidas, prioridades e responsáveis.",
  },
  {
    id: "rel-004",
    nome: "Relatório de emergências",
    tipo: "emergencias",
    descricao: "Histórico de emergências acionadas e status de atendimento.",
  },
  {
    id: "rel-005",
    nome: "Relatório por vigilante",
    tipo: "vigilante",
    descricao: "Movimentações individuais por vigilante.",
  },
];

export const initialData = {
  appConfig,
  condominios,
  postos,
  pontosDeRonda,
  usuarios,
  vigilantes,
  rondas,
  categoriasOcorrencia,
  ocorrencias,
  emergencias,
  passagensTurno,
  checklistPosto,
  registrosSistema,
  modelosRelatorio,
};

// Helpers
export const getById = (arr, id) => arr.find((i) => i.id === id);

export const getUsuarioByEmail = (email) =>
  usuarios.find((u) => u.email.toLowerCase() === String(email).toLowerCase());

export const formatHora = (iso) => {
  if (!iso) return "—";
  const d = new Date(iso);
  return d.toLocaleTimeString("pt-BR", {
    hour: "2-digit",
    minute: "2-digit",
  });
};

export const formatData = (iso) => {
  if (!iso) return "—";
  const d = new Date(iso);
  return d.toLocaleDateString("pt-BR");
};

export const formatDataHora = (iso) => {
  if (!iso) return "—";
  const d = new Date(iso);
  return `${d.toLocaleDateString("pt-BR")} ${d.toLocaleTimeString("pt-BR", {
    hour: "2-digit",
    minute: "2-digit",
  })}`;
};